import type { GetStaticProps, NextPage } from 'next'

import { StoriesPage, StoriesPageProps } from 'src/App/StoriesPage/StoriesPage'
import { strapiGetStories } from 'src/strapi/api/getStories'
import { StoryClientType } from 'src/strapi/types/storiesTypes'

const Stories: NextPage<StoriesPageProps> = (props) => (
  <StoriesPage {...props} />
)

export const getStaticProps: GetStaticProps<StoriesPageProps> = async () => {
  let stories: Array<StoryClientType> = []

  try {
    stories = await strapiGetStories({ withImages: true })

    if (!stories.length) {
      throw new Error('No stories were received for page /stories')
    }
  } catch (error) {
    throw new Error('Failed to build page /stories')
  }

  return {
    revalidate: false,
    props: {
      stories,
    },
  }
}

export default Stories
